import Home from "./Home";
import NotFound from "./NotFound";
import Terms from "./Terms";
import Privacy from "./Privacy";
import Cookies from "./Cookies";

export default {
  Home,
  NotFound,
  Terms,
  Privacy,
  Cookies
};
